import { render, staticRenderFns } from "./SendToScudButton.vue?vue&type=template&id=6fb875a4&"
import script from "./SendToScudButton.vue?vue&type=script&lang=js&"
export * from "./SendToScudButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports